module.exports = __webpack_public_path__ + "img/hair_color_purple.6b45be7.svg";